interface TextMessageProps {
  children: string;
  additionalClasses?: string;
}

function TextMessage({ children, additionalClasses = "" }: TextMessageProps) {
  return (
    <div
      className={`font-['Poppins',Helvetica,Arial,sans-serif] not-italic font-normal text-[#333333] ${additionalClasses}`}
    >
      {children}
    </div>
  );
}

export default TextMessage;

